<template>
    <div class="text-center mt-4 mb-3">
        <a href="#" onclick="return false;" @click="showLessOplist" v-if="!firstLoadAPI && this.page > 1" data-gtm="show_more_less"
            class="automation-readless-button button button-ghost-black uppercase pagination-button show-less ml-2 mr-2">
            {{ showLessText }}
        </a>
        <a href="#" onclick="return false;" @click="showMoreOplist" v-if="this.page < this.totalPages " data-gtm="show_more_less"
            class="automation-readmore-button button button-ghost-black uppercase pagination-button show-more ml-2 mr-2">
            {{ showMoreText }}
        </a>

        <div id="pagination-progress-text" class="mt-3" v-html="this.showingOfText"></div>
        <div>
            <progress id="pagination-progress-bar" :value="this.totalLoaded" :max="totalOplistItems"></progress>
        </div>
    </div>
</template>

<script>
export default {
    name: 'show-more-show-less-button-tw',
    props: {
        containerId: {
            type: String,
            required: true,
        },
        showMoreText: {
            type: String,
            required: true,
        },
        showLessText: {
            type: String,
            required: true,
        },
        defaultShowingOfText: {
            type: String,
            required: true,
        },
        initialItems: {
            type: Number|String,
            required: true,
        },
        itemsPerPage: {
            type: Number|String,
            required: true,
        },
        totalOplistItems: {
            type: Number|String,
            required: true,
        },
        workerApi: {
            typw: String,
            required: true,
        },
        geo: {
            type: String,
            required: true,
        },
        defaultRegion: {
            type: String,
            default: null,
        },
        overrideRegion: {
            type: String,
            default: null,
        },
        oplistHash: {
            type: String,
            required: true,
        },
        rankId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            page: 1,
            endpoint: this.workerApi + '/operator-list?',
            loadedPages: {},
            region: this.defaultRegion,
            showingOfText: this.defaultShowingOfText,
            totalLoaded: this.initialItems,
            totalPages: Math.ceil((this.totalOplistItems - this.initialItems) / this.itemsPerPage) + 1,
            firstLoadAPI: true,
        }
    },
    mounted: function() {
        // Set region if cookie is available
        if ($cookies.isKey(('op_list_region_' + this.geo.toLowerCase()))) {
            this.region = $cookies.get(('op_list_region_' + this.geo.toLowerCase()));
        }
    },
    methods: {
        showMoreOplist() {
            // this.page is not incremented until in the axiosParams()
            if(((this.page + 1) in this.loadedPages)) {
                if (this.getOplistContainer !== false) {
                    this.page++;
                    console.log('Already called API, not calling again. Loading page: ' + this.page);
                    this.showLoadedOplist();
                }
            } else {
                axios
                    .get(this.endpoint, {params: this.axiosParams()})
                    .then((response) => {
                        if(response.data.success) {
                            this.operator_list = response.data.data.operator_list.trim();

                            if (this.getOplistContainer !== false) {
                                this.getOplistContainer.querySelector('ol').innerHTML += this.operator_list;
                                this.updateShowingOfText(
                                    this.totalLoaded,
                                    this.page == this.totalPages ? this.totalOplistItems : (parseInt(this.totalLoaded) + parseInt(this.itemsPerPage))
                                );
                                this.firstLoadAPI = false;
                                this.loadedPages[this.page] = true;
                                setTimeout(() => {
                                    // ktag.reRender() will add data-rendered onto each exit links (<a>)
                                    // However, if we don't remove the data-rendered that's already in the current list
                                    // ktag.reRender will add data-rendered onto the "new list" and sets the "new list" as the list
                                    // Meaning the "old list" that was on the page is now unrecognisable by ktag and won't fire a oplistclk event
                                    let oplistHTML = this.getOplistContainer.querySelector('ol').querySelectorAll('a[data-rendered]')
                                    oplistHTML.forEach(function(exitLinks) {
                                        exitLinks.removeAttribute('data-rendered')
                                    })

                                    ktag.reRender('showmore'); // track impressions and seenopitems and click event
                                }, 500)
                            }else {
                                console.log('Cannot find oplist container');
                            }
                        } else {
                            console.log(response.data.message);
                        }
                    })
                    .catch((error) => {
                        console.log('--------------- error loading worker API ---------------');
                    });
            }
        },
        showLessOplist() {
            if (this.getOplistContainer !== false) {
                this.page--;
                this.showLoadedOplist();

                let scrollOffset = 650; // the higher the value, the higher it scrolls above the pagination container
                window.scroll({
                    top: document.getElementById(this.containerId).getBoundingClientRect().top + window.scrollY - scrollOffset,
                    behavior: 'smooth'
                });
            }
        },
        showLoadedOplist() {
            // This function will show/hide oplist items that are already loaded
            let itemsToShow = parseInt(this.initialItems) + ((this.page - 1) * this.itemsPerPage);
            let items = this.getOplistContainer.querySelectorAll('[data-position]');

            // Don't increment for last page, just set it to the amount of items in the list
            if (this.page == this.totalPages) {
                itemsToShow = items.length;
            }

            console.log('Show Oplist - page: ' + this.page + ' itemsToShow: ' + itemsToShow);

            for(let i = 0; i < items.length; i++){
                if (i >= itemsToShow) {
                    items[i].style.display = 'none';
                }else{
                    items[i].style.display = 'block';
                }
            }

            this.updateShowingOfText(this.totalLoaded, itemsToShow);
        },
        updateShowingOfText(currentLoadedItemsCount, newLoadedItemsCount) {
            this.showingOfText = this.showingOfText.replace(currentLoadedItemsCount, newLoadedItemsCount);
            this.totalLoaded = newLoadedItemsCount;
        },
        axiosParams() {
            const params = new URLSearchParams();
            params.append('geo', this.geo);
            if(this.overrideRegion) {
                params.append('region', this.overrideRegion.toLowerCase());
            } else if(this.region) {
                if(this.geo == "CA" && (this.region != "ON" && this.region != "AB")) {
                    this.region = "AB";
                }
                params.append('region', this.region.toLowerCase());
            } else if(!this.region && this.defaultRegion) {
                params.append('region', this.defaultRegion.toLowerCase());
            }
            params.append('rank_id', this.rankId);
            params.append('hash', this.oplistHash);
            params.append('initial_items', this.initialItems);
            params.append('items_per_page', this.itemsPerPage);
            params.append('page', ++this.page);

            console.log('Calling API - page: ' + this.page + ' initialItems: ' + this.initialItems + ' itemsPerPage: ' + this.itemsPerPage);
            return params;
        }
    },
    computed: {
        getOplistContainer() {
            let siblingElements = document.getElementById(this.containerId).parentNode.children;
            for(let i = 0; i < siblingElements.length; i++) {
                if(siblingElements[i].matches('.cf-primary-operator-list')) {
                    return siblingElements[i];
                }
            }

            return false;
        }
    },
}
</script>

<style scoped>
    #pagination-progress-text {
        font-size: 14px;
        color: #231F20;
    }

    #pagination-progress-bar {
        width: 100px;
        height: 10px;
        border: 0;
        border-radius: 10px;
    }

    #pagination-progress-bar::-webkit-progress-bar {
        background-color: #ecedef;
        height: 10px;
        border-radius: 50px;
    }

    #pagination-progress-bar::-webkit-progress-value {
        background-color: #0157ff;
        border-radius: 50px;
    }

    .pagination-button {
        width: 280px;
        line-height: 50px;
        margin-top: 10px;
        font-weight: 600;
        font-size: 16px;
        color: #231F20;
        border-color: #231F20;
    }
</style>
